export const FEATURE_KEY = "collection";
